export default {
  "common": {
    "whatsapp": "Hai domande? Scrivici su WhatsApp",
    "backToTop": "Torna su"
  },
  "nav": {
    "lang": "Lingua",
    "loginRegister": "Accedi / Registrati",
    "login": "Accedi",
    "products": "Prodotti",
    "how": "Come funziona",
    "manifesto": "Manifesto",
    "faq": "FAQ",
    "sectors": "Settori",
    "cta": "Personalizza la tua card Smart NFC + QR",
    "searchPh": "Cerca prodotti o sezioni…",
    "searchEmpty": "Nessun risultato",
    "pricing": "Prezzi"
  },
  "liveStats": {
    "eyebrow": "Numeri reali, aggiornati in tempo reale",
    "scans": "Scansioni generate dalle card",
    "clicks": "Clic verso le recensioni Google",
    "businesses": "Attività attive"
  },
  "company": {
    "address": "Sede legale",
    "vat": "P.IVA/CUI",
    "vatPending": "in fase di attribuzione",
    "reg": "Reg. Com.",
    "controller": "Titolare del trattamento",
    "dpo": "Contatto privacy"
  },
  "sectorPage": {
    "metaTitle": "Card NFC + QR per {sector}: più recensioni Google in un tocco | InfinityFeedback",
    "metaDesc": "Card smart NFC + QR personalizzata per {sector}: il cliente avvicina il telefono e lascia la recensione Google in 3 secondi. Frase pronta: \"{text}\". Da 24,90 €, primo anno di servizio incluso.",
    "breadcrumb": "Settori",
    "productName": "Card Smart NFC + QR Google Recensioni",
    "h1a": "Più recensioni Google per",
    "cta": "Crea la card per la tua attività",
    "how": "Come funziona",
    "exampleName": "{sector} Aurora",
    "exampleCity": "Milano",
    "exampleCaption": "Esempio di card preconfigurata per il settore: colori, layout e frase già ottimizzati (modificabili).",
    "whyEyebrow": "Perché funziona",
    "whyTitle": "Il momento giusto per chiedere una recensione a un cliente di {sector} esiste già. Basta coglierlo.",
    "includedEyebrow": "Tutto incluso",
    "includedTitle": "Una card, zero canoni nascosti.",
    "included": [
      "Chip NFC NTAG216 + QR ad alta risoluzione, collegati alla tua pagina recensioni Google",
      "Design personalizzato: logo, colori, carattere e frase settore (anteprima live)",
      "Piano Reputazione Continua: primo anno incluso, poi 29 €/anno (disdici quando vuoi)",
      "Area Titolare con statistiche scansioni, report mensile via e-mail e canale privato Insta-Resolve",
      "Spedizione in tutta Europa, gratuita sopra i 50 €"
    ],
    "plan": "1° anno di servizio incluso",
    "priceEyebrow": "Prezzo una tantum",
    "priceNote": "Scegli la finitura PVC: Lucido, Eco riciclato, Opaco Premium o Crystal trasparente.",
    "faqTitle": "Domande frequenti — {sector}",
    "related": "Settori affini",
    "faq": [
      {
        "q": "Dove posiziono la card in un'attività come {sector}?",
        "a": "Nel punto in cui il cliente conclude l'esperienza con un'emozione positiva: cassa, reception, tavolo, scrivania o porta-conto. Il kit da 3 card copre più postazioni."
      },
      {
        "q": "Serve un'app o un abbonamento per {sector}?",
        "a": "No. Il cliente avvicina il telefono (NFC) o inquadra il QR: si apre la tua pagina recensioni. Il primo anno di servizio è incluso; poi 29 €/anno per statistiche, report e supporto."
      },
      {
        "q": "È conforme alle regole di Google?",
        "a": "Sì: la card invita a lasciare un'opinione autentica e non filtra le recensioni. Il canale privato Insta-Resolve serve solo a gestire meglio i problemi, senza impedire la pubblicazione."
      },
      {
        "q": "Quanto tempo ci vuole?",
        "a": "Configuri la card in 5 passi, la ricevi in 2-5 giorni lavorativi (express disponibile) e funziona subito, senza installazioni."
      }
    ],
    "angles": {
      "food": {
        "intro": "Nel {sector} il cliente decide se lasciare una recensione nei 30 secondi dopo aver pagato. La card sul porta-conto o al banco trasforma quel momento in stelle su Google, senza chiedere nulla a voce.",
        "points": [
          {
            "t": "Al momento del conto",
            "d": "Il cliente ha il telefono in mano e l'esperienza ancora fresca: un tocco e la recensione è fatta."
          },
          {
            "t": "Nessuna pressione",
            "d": "Niente richieste imbarazzanti per lo staff: la card lavora da sola, in ogni turno, ogni giorno."
          },
          {
            "t": "Gestisci i problemi in privato",
            "d": "Con Insta-Resolve un ospite deluso può scriverti prima di pubblicare: recuperi la relazione e proteggi il rating."
          }
        ]
      },
      "beauty": {
        "intro": "Chi esce da {sector} si sente bene e vuole dirlo. La card alla cassa o allo specchio raccoglie quell'entusiasmo e lo porta su Google, dove i nuovi clienti scelgono a chi affidarsi.",
        "points": [
          {
            "t": "L'effetto \"wow\" va catturato subito",
            "d": "Il risultato è visibile e l'umore è alto: il momento perfetto per una recensione a 5 stelle."
          },
          {
            "t": "Immagine premium",
            "d": "Card opaca, crystal o eco con il tuo logo: un dettaglio di stile coerente con il tuo salone."
          },
          {
            "t": "Clienti che tornano",
            "d": "Chi lascia una recensione si ricorda di te e prenota di nuovo: reputazione e fidelizzazione insieme."
          }
        ]
      },
      "health": {
        "intro": "Per {sector} la fiducia è tutto: il 90% dei pazienti e dei clienti legge le recensioni prima di scegliere. La card sulla scrivania o in reception rende naturale chiedere un parere, con discrezione.",
        "points": [
          {
            "t": "Discrezione professionale",
            "d": "Nessuna richiesta esplicita: la card invita con eleganza, in linea con il decoro del tuo studio."
          },
          {
            "t": "Conformità e trasparenza",
            "d": "Recensioni autentiche e non filtrate, nel rispetto delle policy Google e del codice deontologico."
          },
          {
            "t": "Report mensile",
            "d": "Sai quante persone hanno scansionato la card e quante hanno aperto Google: dati reali, ogni mese via e-mail."
          }
        ]
      },
      "services": {
        "intro": "Nei servizi come {sector} il cliente giudica affidabilità e puntualità. La card consegnata a fine intervento o esposta al banco raccoglie il feedback quando la soddisfazione è massima.",
        "points": [
          {
            "t": "A lavoro concluso",
            "d": "Il problema è risolto e il cliente è grato: il tocco sulla card trasforma la gratitudine in una recensione."
          },
          {
            "t": "Anche fuori sede",
            "d": "Portala con te: la card funziona ovunque, in cantiere, a domicilio o in ufficio."
          },
          {
            "t": "Più chiamate dai risultati locali",
            "d": "Le recensioni recenti migliorano la posizione su Google Maps: più visibilità, più richieste."
          }
        ]
      },
      "sport": {
        "intro": "In {sector} l'energia dopo l'allenamento o la serata è il miglior carburante per una recensione. La card alla reception o al bancone intercetta quel momento, ogni giorno.",
        "points": [
          {
            "t": "Endorfine = recensioni",
            "d": "A fine sessione l'entusiasmo è al massimo: un tocco e il cliente racconta la sua esperienza."
          },
          {
            "t": "Kit da 3 card",
            "d": "Reception, spogliatoio e bar: più punti di contatto, più recensioni nel weekend."
          },
          {
            "t": "Community più forte",
            "d": "Le recensioni pubbliche attirano nuovi iscritti e rafforzano il senso di appartenenza."
          }
        ]
      },
      "retail": {
        "intro": "In {sector} ogni acquisto è un'occasione: la card in cassa o nel pacchetto invita il cliente a raccontare la sua esperienza su Google mentre è ancora soddisfatto dell'acquisto.",
        "points": [
          {
            "t": "Alla cassa o nel pacchetto",
            "d": "Il cliente tocca la card mentre paga o quando apre la busta a casa: due momenti, una recensione."
          },
          {
            "t": "Batti i grandi marketplace",
            "d": "Le recensioni locali su Google portano chi cerca vicino a te direttamente in negozio."
          },
          {
            "t": "Design coordinato",
            "d": "Colori e logo del tuo brand sulla card: un piccolo oggetto di design che parla di te."
          }
        ]
      }
    }
  },
  "seo": {
    "homeTitle": "InfinityFeedback — Card NFC + QR per recensioni Google | Da 24,90 €",
    "homeDesc": "Card smart NFC + QR personalizzata: il cliente avvicina il telefono e lascia la recensione Google in 3 secondi. 4 finiture PVC, spedizione in Europa, primo anno di servizio incluso.",
    "cfgTitle": "Configura la tua card NFC + QR in 5 passi | InfinityFeedback",
    "cfgDesc": "Scegli finitura PVC, settore, logo, colori e frase: anteprima live della card, verifica del link Google e checkout sicuro con Stripe."
  },
  "greviews": {
    "eyebrow": "Recensioni verificate Google",
    "title": "Quello che i nostri clienti scrivono su Google.",
    "total": "{{n}} recensioni su Google"
  },
  "referral": {
    "eyebrow": "Regala uno sconto ai tuoi amici",
    "title": "Il tuo codice amico: −{{pct}}% per chi lo usa",
    "sub": "Al {{n}}° utilizzo ricevi via e-mail un codice −{{bonus}}% personale. Condividilo con colleghi e attività amiche.",
    "copied": "Codice copiato!",
    "whatsapp": "Invia su WhatsApp",
    "uses": "Usato da {{n}} persone · mancano {{left}} al bonus",
    "shareText": "Ho appena preso la card NFC + QR per le recensioni Google di InfinityFeedback. Con il mio codice {{code}} hai il {{pct}}% di sconto: {{url}}"
  },
  "blog": {
    "eyebrow": "Blog",
    "title": "Guide pratiche per ottenere più recensioni Google.",
    "sub": "Metodo, regole e strumenti per trasformare clienti soddisfatti in reputazione online, senza imbarazzo e nel rispetto delle policy Google.",
    "metaTitle": "Blog — Come ottenere recensioni Google: guide pratiche | InfinityFeedback",
    "metaDesc": "Guide su come chiedere recensioni Google, NFC vs QR, gestione delle recensioni negative, SEO locale e regole Google. Dal team InfinityFeedback.",
    "minutes": "{{n}} min",
    "read": "Leggi l'articolo",
    "back": "Tutti gli articoli",
    "more": "Continua a leggere",
    "ctaTitle": "Metti in pratica con la tua card NFC + QR",
    "ctaSub": "Configurala in 5 passi: da 24,90 €, primo anno di servizio incluso."
  },
  "sectorsCustom": {
    "label": "La tua attività non è in elenco? Scrivila qui",
    "placeholder": "Es. Studio di tatuaggi, Autolavaggio…",
    "btn": "Configura la mia card"
  },
  "newsletter": {
    "eyebrow": "Newsletter per titolari",
    "title": "Una guida pratica al mese per avere più recensioni Google.",
    "sub": "Consigli operativi, nuovi articoli e promozioni riservate agli iscritti. Niente spam: massimo due e-mail al mese, disiscrizione con un clic.",
    "placeholder": "La tua e-mail di lavoro",
    "cta": "Iscrivimi",
    "consent": "Ho letto l'<1>informativa privacy</1> e acconsento a ricevere la newsletter di InfinityFeedback.",
    "consentErr": "Accetta l'informativa privacy per iscriverti.",
    "okTitle": "Iscrizione confermata!",
    "okSub": "Controlla la casella: ti abbiamo appena inviato l'e-mail di benvenuto.",
    "already": "Sei già iscritto con questa e-mail.",
    "err": "Iscrizione non riuscita. Riprova tra poco."
  },
  "hero": {
    "ctaStandard": "Card Smart Standard Google Recensioni NFC + QR",
    "ctaStandardL1": "Card Smart Standard",
    "ctaStandardL2": "Google Recensioni NFC + QR",
    "ctaCustomize": "Personalizza la tua card NFC + QR",
    "ctaNote": "NFC + QR integrati · Recensioni Google · da 19,99 €",
    "loopOpened": "Pagina recensioni aperta in 1 secondo",
    "h1a": "Fatti notare, fatti ricordare.",
    "h1b": "Dai un’energia nuova alle tue recensioni.",
    "badge": "Un tocco. Una recensione. NFC + QR integrati",
    "ctaQr": "Personalizzala QR",
    "ctaProducts": "Scopri i prodotti",
    "eyebrow": "TESSERE SMART NFC + QR PER GOOGLE REVIEWS",
    "l1": "Eleva la reputazione",
    "l2": "digitale della tua attività",
    "l3": "con un solo tocco.",
    "sub": "Tessere, carte e biglietti da visita di design con chip NFC e QR code di ultima generazione. I tuoi clienti lasciano una recensione autentica su Google in tempo reale — senza app, senza attriti.",
    "cta1": "Personalizza la tua card Smart NFC + QR",
    "cta2": "Scopri i prodotti",
    "rating": "Recensioni autentiche",
    "secure": "Pagamenti sicuri Stripe",
    "badge1": "Un tocco. Una recensione.",
    "badge2": "NFC + QR integrati",
    "ctaFree": "Inizia gratis",
    "ctaDemo": "Guarda demo"
  },
  "marquee": {
    "items": [
      "Recensioni Google in un tocco",
      "Tecnologia NFC",
      "QR Code ad alta risoluzione",
      "Nessun abbonamento obbligatorio",
      "Spedizione rapida in Europa",
      "Ritiro a Rimini & Cluj-Napoca",
      "Hotel · Ristoranti · Professionisti"
    ]
  },
  "products": {
    "eyebrow": "La vetrina",
    "title": "Strumenti di reputazione, progettati come oggetti di design.",
    "sub": "Ogni supporto è configurabile in cinque passaggi: formato, colori, carattere, logo, foto e link Google. Prezzo una tantum per la card, primo anno di servizio incluso.",
    "configure": "Configura"
  },
  "smart": {
    "eyebrow": "Le nostre Card Smart Google Recensioni",
    "title": "Standard o Premium: scegli la tua Card Smart Google Recensioni NFC + QR.",
    "blue": "Blu",
    "black": "Nera",
    "includedTitle": "Incluso",
    "idealTitle": "Ideale per",
    "presetBlue": "Grafica Google Recensioni pronta, versione Blu. Colori e layout fissi, testi e QR personalizzati sul retro.",
    "presetBlack": "Grafica Google Recensioni pronta, versione Nera. Colori e layout fissi, testi e QR personalizzati sul retro.",
    "cfgTitle": "A. Card Smart Google Recensioni",
    "cfgSub": "Standard (senza logo, pronta all'uso) oppure Premium con il tuo logo. Disponibili in blu e nero.",
    "std": {
      "badge": "Standard",
      "title": "Card Smart Google Recensioni NFC + QR",
      "note": "Versione blu o nera, senza logo personalizzato.",
      "cta": "Ordina la Standard",
      "included": [
        "Tecnologia NFC integrata",
        "QR Code",
        "Collegamento diretto alla tua pagina Google",
        "Compatibile con Android e iPhone",
        "Nessuna app necessaria",
        "Pronta all'uso"
      ],
      "ideal": [
        "Ristoranti",
        "Bar",
        "Parrucchieri",
        "Centri estetici",
        "Hotel",
        "Negozi",
        "Professionisti"
      ]
    },
    "prem": {
      "badge": "Premium",
      "title": "Card Smart Google Recensioni NFC + QR Personalizzata",
      "note": "Versione blu o nera con \"Il tuo Logo Qui\".",
      "cta": "Ordina la Premium",
      "included": [
        "Tutto ciò che comprende la versione Standard",
        "Logo aziendale personalizzato",
        "Grafica personalizzata con i colori del brand",
        "Card esclusiva e professionale",
        "Design premium"
      ],
      "tagline": "Perfetta per chi desidera rafforzare l'immagine del proprio brand."
    },
    "whyTitle": "Perché scegliere InfinityFeedback?",
    "why": [
      "NFC + QR Code",
      "Nessuna batteria",
      "Nessun abbonamento obbligatorio",
      "Configurazione inclusa",
      "Materiali di alta qualità",
      "Design elegante e professionale",
      "Aumenta le recensioni Google in modo semplice"
    ],
    "ctaEyebrow": "Inizia oggi",
    "ctaTitle": "Inizia a ricevere più recensioni oggi stesso.",
    "ctaText": "Ordina la tua Card Smart Google Recensioni e rendi più semplice per i tuoi clienti lasciare una recensione con un semplice tocco.",
    "pick": "La nostra selezione",
    "faqTitle": "Domande frequenti sulle Card Smart",
    "faq": [
      {
        "q": "Come funziona la card? Serve un'app?",
        "a": "No. Il cliente avvicina lo smartphone alla card (NFC) oppure inquadra il QR: si apre direttamente la pagina per lasciare la recensione Google della tua attività. Funziona con Android e iPhone."
      },
      {
        "q": "Qual è la differenza tra Standard e Premium?",
        "a": "La Standard ha una grafica Google Recensioni pronta (blu o nera) senza logo. La Premium aggiunge il tuo logo e i colori del brand per una card esclusiva e professionale."
      },
      {
        "q": "Ci sono costi ricorrenti o batterie?",
        "a": "Nessun abbonamento e nessuna batteria: la card funziona per sempre con un unico pagamento. Il collegamento alla tua pagina Google è incluso e modificabile."
      },
      {
        "q": "Quanto tempo serve per riceverla?",
        "a": "Configuri la card online in pochi minuti; la produzione e la spedizione in Europa richiedono in genere 3-5 giorni lavorativi."
      }
    ]
  },
  "prodData": {
    "smart_std_blue": {
      "name": "Card Smart Google Recensioni",
      "variant": "Standard · Blu",
      "tag": "Pronta all'uso",
      "short": "Grafica Google Recensioni pronta, senza logo: NFC + QR, collegamento diretto alla tua pagina Google.",
      "format": "PVC · 85,6 × 54 mm · chip NFC NTAG213 · QR stampato",
      "extra": null
    },
    "smart_std_black": {
      "name": "Card Smart Google Recensioni",
      "variant": "Standard · Nera",
      "tag": "Pronta all'uso",
      "short": "Versione nera elegante, senza logo: NFC + QR, collegamento diretto alla tua pagina Google.",
      "format": "PVC · 85,6 × 54 mm · chip NFC NTAG213 · QR stampato",
      "extra": null
    },
    "smart_prem_blue": {
      "name": "Card Smart Google Recensioni",
      "variant": "Premium · Blu",
      "tag": "Con il tuo logo",
      "short": "Il tuo logo e i colori del brand su una card esclusiva e professionale.",
      "format": "PVC · 85,6 × 54 mm · chip NFC NTAG216 · logo e grafica personalizzati",
      "extra": "Logo personalizzato incluso"
    },
    "smart_prem_black": {
      "name": "Card Smart Google Recensioni",
      "variant": "Premium · Nera",
      "tag": "Con il tuo logo",
      "short": "Versione nera premium con il tuo logo e i colori del brand.",
      "format": "PVC · 85,6 × 54 mm · chip NFC NTAG216 · logo e grafica personalizzati",
      "extra": "Logo personalizzato incluso"
    },
    "pvc_gloss_standard": {
      "name": "PVC Lucido",
      "variant": "Standard",
      "tag": "Essenziale",
      "short": "Finitura lucida brillante, colori vividi e resistenza quotidiana.",
      "format": "PVC lucido · 85,6 × 54 mm · chip NFC NTAG213 · QR inciso",
      "extra": null
    },
    "pvc_eco_recycled": {
      "name": "PVC Riciclato",
      "variant": "Eco-Friendly",
      "tag": "Sostenibile",
      "short": "PVC riciclato certificato, stessa durata, impatto ridotto.",
      "format": "PVC riciclato · 85,6 × 54 mm · chip NFC NTAG213 · finitura satinata",
      "extra": "+ € 3,00 rispetto alla Standard"
    },
    "pvc_matte_premium": {
      "name": "PVC Opaco",
      "variant": "Premium",
      "tag": "Più venduta",
      "short": "Finitura opaca soft-touch anti-impronta: eleganza al tatto.",
      "format": "PVC opaco soft-touch · 85,6 × 54 mm · chip NFC NTAG216 · bordo rinforzato",
      "extra": "+ € 5,00 rispetto alla Standard"
    },
    "pvc_crystal_clear": {
      "name": "PVC Trasparente",
      "variant": "Crystal",
      "tag": "Esclusiva",
      "short": "Card trasparente effetto cristallo: il tuo logo sembra sospeso.",
      "format": "PVC trasparente crystal · 85,6 × 54 mm · chip NFC NTAG216 · stampa bianca coprente",
      "extra": "+ € 10,00 rispetto alla Standard"
    },
    "card_standard": {
      "name": "Card Recensioni Google",
      "variant": "Standard",
      "tag": "Essenziale",
      "short": "La via più semplice per invitare i clienti a recensirti su Google.",
      "format": "PVC premium · 85,6 × 54 mm · angoli arrotondati · finitura lucida",
      "extra": null
    },
    "card_premium": {
      "name": "Card Recensioni Google",
      "variant": "Premium",
      "tag": "Più venduta",
      "short": "Personalizzata con il tuo logo e i tuoi colori aziendali.",
      "format": "PVC premium · 85,6 × 54 mm · stampa full color fronte/retro · cornice incisa",
      "extra": "+10,00 € rispetto alla Standard — personalizzazione con logo e colori aziendali"
    },
    "kit_3_premium": {
      "name": "Kit 3 Tessere Premium",
      "variant": "Multi-postazione",
      "tag": "Per team e sedi",
      "short": "Tre tessere coordinate per reception, sala e cassa.",
      "format": "3 × PVC premium · 85,6 × 54 mm · grafica coordinata · un unico link",
      "extra": "Include 3 tessere premium coordinate con un unico link Google Reviews"
    },
    "smart_business_card": {
      "name": "Biglietto da Visita Smart",
      "variant": "NFC + QR",
      "tag": "Networking",
      "short": "Il biglietto da visita che trasforma ogni incontro in un contatto.",
      "format": "PVC · 54 × 85,6 mm verticale · fronte/retro · contatti programmati",
      "extra": "+15,00 € rispetto alla Standard — grafica personalizzata fronte/retro e programmazione contatti"
    },
    "card_boutique_wood": {
      "name": "Card Boutique",
      "variant": "Legno Naturale",
      "tag": "Artisanal",
      "short": "Legno naturale inciso a laser: calore artigianale per location di charme.",
      "format": "Legno naturale · 85 × 54 mm · incisione laser · venature uniche",
      "extra": null
    },
    "card_boutique_steel": {
      "name": "Card Boutique",
      "variant": "Acciaio Spazzolato",
      "tag": "Luxury",
      "short": "Acciaio spazzolato con incisione di precisione: presenza scenografica per hotel di lusso.",
      "format": "Acciaio inox spazzolato · 85 × 54 mm · incisione di precisione",
      "extra": null
    }
  },
  "about": {
    "eyebrow": "Chi siamo & cosa offriamo",
    "title": "Il ponte fisico tra il tuo locale e la tua reputazione online.",
    "body": "InfinityFeedback progetta tessere, carte e biglietti da visita originali e personalizzati, dotati di tecnologia NFC e QR code di ultima generazione. Il cliente avvicina lo smartphone o inquadra il codice: si apre direttamente la tua scheda Google, pronta per ricevere una recensione autentica.",
    "f1t": "NFC contactless",
    "f1d": "Un tocco e la pagina recensioni si apre all'istante.",
    "f2t": "QR di ultima generazione",
    "f2d": "Compatibile con ogni smartphone, senza app.",
    "f3t": "Link verificato",
    "f3d": "Agganciamo la tua scheda Google prima del pagamento.",
    "f4t": "Consegna UE",
    "f4d": "Spedizione standard o ritiro a Rimini e Cluj-Napoca."
  },
  "sectors": {
    "eyebrow": "Pensato per ogni attività",
    "title": "Tutti i settori, un solo gesto.",
    "sub": "Filtra per categoria e scopri come la Smart Card NFC + QR si adatta alla tua realtà: dalla reception dell'hotel allo studio professionale, la richiesta di recensione diventa automatica.",
    "all": "Tutte",
    "categories": [
      {
        "name": "Ristorazione e Accoglienza",
        "items": [
          "Ristoranti",
          "Pizzerie",
          "Bar & Caffetterie",
          "Gelaterie & Pasticcerie",
          "Hotel",
          "B&B & Case Vacanza",
          "Stabilimenti Balneari",
          "Discoteche & Lounge Bar"
        ]
      },
      {
        "name": "Benessere e Cura della Persona",
        "items": [
          "Centri Estetici",
          "Saloni di Parrucchieri & Barber Shop",
          "Spa & Centri Benessere",
          "Studi di Medicina Estetica"
        ]
      },
      {
        "name": "Professionisti e Studi",
        "items": [
          "Studi Medici & Odontoiatrici",
          "Studi Legali & Notarili",
          "Commercialisti & Consulenti Finanziari",
          "Agenzie Immobiliari",
          "Architetti & Designer"
        ]
      },
      {
        "name": "Retail e Attività Commerciali",
        "items": [
          "Negozi di Abbigliamento & Boutique",
          "Gioiellerie",
          "Ottici",
          "Farmacie & Parafarmacie",
          "Concessionarie Auto & Officine Meccaniche",
          "Palestre & Centri Sportivi",
          "Fioristi",
          "Tabaccherie & Edicole"
        ]
      },
      {
        "name": "Servizi e Artigiani",
        "items": [
          "Idraulici",
          "Elettricisti",
          "Imprese di Pulizie",
          "Autonoleggi",
          "Co-working e Centri Congressi"
        ]
      }
    ]
  },
  "manifesto": {
    "eyebrow": "Il manifesto",
    "c1t": "La prima impressione è digitale",
    "c1d": "Prima di entrare nel tuo locale, i clienti leggono le recensioni. Un rating alto non è un optional: è la tua vetrina. Una card smart trasforma ogni cliente soddisfatto in un ambasciatore pubblico del tuo brand.",
    "c2t": "La barriera del feedback, eliminata",
    "c2d": "Chiedere una recensione a voce è scomodo. Cercare la scheda su Google è tedioso. Con NFC e QR il percorso diventa un solo gesto: tocca, scrivi, pubblica. Il feedback arriva quando l'esperienza è ancora viva.",
    "c3t": "Reputazione che scala, in automatico",
    "c3d": "Ogni tessera lavora per te 24 ore su 24: alla cassa, in reception, sul tavolo. Le recensioni crescono, il rating locale si consolida e la fiducia dei nuovi clienti arriva prima ancora che varchino la porta."
  },
  "testimonials": {
    "eyebrow": "Storie di clienti",
    "title": "Chi l'ha provata, il rating l'ha visto crescere.",
    "sub": "Attività come la tua, con la card all'ingresso, in cassa o sul tavolo: più recensioni, più fiducia, più clienti.",
    "items": [
      {
        "q": "Prima chiedere una recensione era imbarazzante per lo staff. Ora la card è sul banco della reception e gli ospiti la usano mentre aspettano il taxi: in novanta giorni siamo passati da 4,2 a 4,7 stelle.",
        "n": "Giulia Mancini",
        "r": "Direttrice · Hotel Villa Adriatica",
        "l": "Rimini (IT)",
        "m": "4,2 → 4,7 ★",
        "p": "PVC Opaco Premium"
      },
      {
        "q": "L'abbiamo messa nel porta-conto. Il cliente paga, avvicina il telefono e la recensione è fatta prima ancora di alzarsi. +138 recensioni in un trimestre senza dover dire una parola.",
        "n": "Marco Tedeschi",
        "r": "Titolare · Osteria del Borgo",
        "l": "Bologna (IT)",
        "m": "+138 recensioni / 90 gg",
        "p": "PVC Lucido"
      },
      {
        "q": "Ogni consulenza si chiude con un tocco sulla mia card trasparente: è elegante, fa parlare e mi ha portato 27 recensioni a cinque stelle in due mesi. Il piano annuale con il report mensile vale da solo il prezzo.",
        "n": "Andreea Popescu",
        "r": "Consulente finanziaria indipendente",
        "l": "Cluj-Napoca (RO)",
        "m": "27 recensioni ★★★★★",
        "p": "PVC Crystal"
      },
      {
        "q": "Kit da tre card: cassa, sala e bancone. Nel weekend, quando il locale è pieno, le recensioni arrivano da sole. Il grafico settimanale nell'Area Titolare ci dice anche quale postazione funziona meglio.",
        "n": "Ștefan Dumitrescu",
        "r": "Co-fondatore · Origo Coffee Lab",
        "l": "Bucarest (RO)",
        "m": "Recensioni weekend ×3",
        "p": "Kit 3 card"
      },
      {
        "q": "Nel mio studio la fiducia è tutto. La card Eco riciclata sulla scrivania racconta chi siamo e in quattro mesi ha portato 41 recensioni, tutte spontanee. Nessuna app, nessun QR stampato male.",
        "n": "Dott.ssa Elena Ricci",
        "r": "Dentista · Studio Ricci & Partners",
        "l": "Verona (IT)",
        "m": "41 recensioni / 4 mesi",
        "p": "PVC Eco riciclato"
      },
      {
        "q": "Spedizione express, arrivata in due giorni con la guida ai template. Il mio parrucchiere di fiducia me l'aveva consigliata: ora la uso alla cassa del salone e ho superato i 200 giudizi su Google.",
        "n": "Luca Ferraro",
        "r": "Titolare · Ferraro Hair Atelier",
        "l": "Torino (IT)",
        "m": "200+ recensioni Google",
        "p": "PVC Opaco Premium"
      }
    ],
    "verified": "Recensione verificata"
  },
  "faq": {
    "eyebrow": "Domande frequenti",
    "title": "Acquisti in Europa, senza pensieri.",
    "sub": "Fiscalità UE, fatturazione e logistica — spiegati in chiaro.",
    "items": [
      {
        "q": "Chi emette la fattura e con quale Partita IVA?",
        "a": "InfinityFeedback è in fase di costituzione: denominazione, sede legale e Partita IVA saranno pubblicati in questa pagina e nelle condizioni di vendita appena la registrazione sarà completata. Nel frattempo gli ordini sono gestiti in modalità di lancio con pagamento sicuro tramite Stripe e assistenza diretta."
      },
      {
        "q": "Come funziona l'IVA per i miei acquisti?",
        "a": "Per i clienti privati (B2C) l'IVA viene applicata e calcolata automaticamente al checkout secondo la normativa UE sulle vendite a distanza (regime OSS). Per i clienti business con Partita IVA valida (B2B) le cessioni intracomunitarie possono beneficiare del reverse charge: inserisci la tua Partita IVA al checkout e riceverai fattura conforme."
      },
      {
        "q": "Ricevo una fattura valida per la mia contabilità?",
        "a": "La fattura viene generata in PDF e inviata via e-mail automaticamente non appena i dati fiscali della società saranno attivi. Per gli ordini effettuati prima, la fattura ti verrà inviata appena disponibile."
      },
      {
        "q": "Quanto costa e quanto dura la spedizione?",
        "a": "La spedizione standard in tutta l'UE costa € 6,90 e richiede 3-5 giorni lavorativi. Se operi nelle nostre aree hub, puoi ritirare gratuitamente a mano a Rimini (IT) o Cluj-Napoca (RO), con supporto diretto della rete di vendita locale."
      },
      {
        "q": "Cosa succede se cambio il link della mia scheda Google?",
        "a": "Nessun problema: il QR code e il chip NFC puntano alla tua pagina recensioni intelligente, non al link Google fisso. Con il Piano Reputazione Continua aggiorni l'URL in tempo reale, senza ristampare la card. Ti consigliamo comunque di verificare l'anteprima di conferma prima del pagamento."
      },
      {
        "q": "La card funziona con tutti gli smartphone?",
        "a": "Sì. Il chip NFC funziona con tutti gli iPhone dal modello 7 in poi e con la quasi totalità degli smartphone Android con NFC attivo. E in ogni caso il QR code sul retro funziona con la fotocamera di qualsiasi telefono, anche senza NFC: nessun cliente resta escluso."
      },
      {
        "q": "Serve una batteria o manutenzione? Quanto dura?",
        "a": "Nessuna batteria e nessuna manutenzione: il chip NFC è passivo e si alimenta dal campo magnetico del telefono. La card è realizzata in materiali resistenti ad acqua e urti, con durata praticamente illimitata."
      },
      {
        "q": "Devo installare o pagare un'app?",
        "a": "No. Né tu né i tuoi clienti dovete installare nulla. Nessun canone mensile né costi nascosti: paghi la card una sola volta e il primo anno di servizio è incluso. Dal secondo anno il Piano Reputazione Continua (29 €/anno) mantiene attivi link dinamico, report mensile e supporto prioritario."
      },
      {
        "q": "Fate condizioni dedicate per ordini B2B di grandi quantità?",
        "a": "Sì. Per catene di hotel, gruppi di ristoranti, franchising o ordini oltre i 20 pezzi prepariamo un listino dedicato con condizioni personalizzate. Scrivici su WhatsApp o via e-mail indicando quantità e tempistiche: rispondiamo entro 24 ore lavorative."
      },
      {
        "q": "Cosa include il canone di 29 €/anno dal secondo anno?",
        "a": "Il primo anno è sempre incluso nel prezzo della card. Dal secondo anno, il Piano Reputazione Continua (29 €/anno) mantiene attivo l'intero ecosistema: link dinamico aggiornabile senza ristampare le card, report mensile di analisi della reputazione via email e accesso prioritario all'assistenza dedicata. Rinnovo annuale automatico con promemoria via e-mail prima della scadenza: puoi disdire liberamente in qualsiasi momento."
      }
    ]
  },
  "delivery": {
    "eyebrow": "Logistica",
    "title": "Consegna europea, ritiro locale.",
    "d4t": "Spedizione Express (via aerea)",
    "d4d": "Consegna rapida in 24-72 ore in tutta Europa. € 9,90, tracciata. Gratuita sopra i 50 €.",
    "d4tag": "€ 9,90",
    "d1t": "Spedizione Standard UE",
    "d1d": "Consegna in 3-5 giorni lavorativi in tutta l'Unione Europea. € 6,90, tracciata.",
    "d1tag": "€ 6,90",
    "d2t": "Ritiro a Rimini (IT)",
    "d2d": "Ritira di persona il tuo ordine nel nostro punto hub di Rimini, con supporto della rete locale.",
    "d2tag": "Gratuito",
    "d3t": "Ritiro a Cluj-Napoca (RO)",
    "d3d": "Ritiro diretto presso la sede operativa di Cluj-Napoca, cuore produttivo di InfinityFeedback.",
    "d3tag": "Gratuito"
  },
  "ctafinal": {
    "title": "La prossima recensione autentica è a un tocco di distanza.",
    "sub": "Configura ora la tua card smart: 5 passaggi, anteprima in tempo reale, link Google verificato prima del pagamento.",
    "cta": "Personalizza la tua card Smart NFC + QR"
  },
  "footer": {
    "withdrawal": "Recesso e Rimborsi",
    "desc": "Soluzioni fisiche smart con tecnologia NFC e QR di ultima generazione per elevare la reputazione digitale di hotel, esercizi commerciali e professionisti in tutta Europa.",
    "vat": "Attività in fase di costituzione nell'Unione Europea: denominazione, sede legale e Partita IVA saranno pubblicati al completamento della registrazione.",
    "legal": "Legale",
    "delivery": "Consegna & Ritiro",
    "privacy": "Privacy Policy",
    "cookie": "Cookie Policy",
    "terms": "Termini e Condizioni di Vendita",
    "admin": "Area Riservata",
    "deliverySummary": "Consegna & Ritiro: 3-5 giorni lavorativi in UE, ritiro gratuito su appuntamento",
    "ship": "Spedizione standard in tutta l'UE",
    "pickupIt": "Ritiro a Rimini (IT)",
    "pickupRo": "Ritiro a Cluj-Napoca (RO)",
    "rights": "InfinityFeedback. Tutti i diritti riservati.",
    "tagline": "NFC · QR · Google Reviews — Feedback autentico, senza attriti."
  },
  "cfg": {
    "standTitle": "Espositore da banco in rovere naturale",
    "standDesc": "Supporto minimal in rovere massello con fessura inclinata (15–20°): tiene la card sempre in vista in cassa, al tavolo o alla reception. Dimensioni proporzionate alla card.",
    "standAdd": "Aggiungi l'espositore",
    "standQty": "Quantità espositori",
    "standEach": "cad.",
    "referralUses": "Usato da {{n}} persone · a 3 utilizzi ricevi via e-mail un codice −{{pct}}% personale (mancano {{left}}).",
    "referralBonus": "Bonus sbloccato: {{code}}",
    "rewardHint": "Condividi l'anteprima e sblocca subito il 10% di sconto (valido 7 giorni).",
    "rewardActive": "−{{pct}}% sbloccato, applicato in automatico al checkout fino al {{date}}.",
    "rewardToast": "Grazie per la condivisione! Codice {{code}}: −{{pct}}% applicato in automatico al checkout.",
    "download": "Scarica anteprima (PNG)",
    "share": "Condividi anteprima",
    "downloadOk": "Anteprima scaricata: mostrala al tuo team o condividila.",
    "shareErr": "Condivisione non riuscita, riprova.",
    "shareText": "Guarda la card NFC + QR di {{name}} per le recensioni Google — creata su InfinityFeedback",
    "sectorGroupPick": "Scegli la categoria, poi il settore",
    "sectorChosen": "Settore scelto",
    "uploading": "Caricamento…",
    "eyebrow": "Configuratore interattivo",
    "title": "Crea la tua card smart, Standard oppure Personalizzata, in 5 passaggi.",
    "steps": [
      "Scelta Card & Attività",
      "Caricamento Logo & Grafica",
      "Configurazione Chip NFC",
      "Riepilogo & Dati Spedizione",
      "Pagamento Sicuro"
    ],
    "pvcTitle": "A. Scegli la tua card in PVC",
    "pvcSub": "Quattro finiture, un unico standard di qualità europeo.",
    "boutiqueToggle": "Collezione Boutique (legno, acciaio, biglietto smart, kit)",
    "sectorTitle": "B. La tua attività",
    "sectorSub": "Il settore pre-imposta layout, palette e testo della card: potrai comunque cambiarli.",
    "sectorLabel": "Settore",
    "sectorPh": "Seleziona il tuo settore…",
    "sectorOtherLabel": "Descrivi la tua attività",
    "sectorOtherPh": "es. Noleggio bici elettriche",
    "nfcTitle": "Configurazione Chip NFC",
    "nfcSub": "Il chip e il QR puntano alla tua scheda Google: verifichiamo il link prima di codificare la card.",
    "recapTitle": "Riepilogo & Dati Spedizione",
    "recapSub": "Controlla la configurazione, i tempi di consegna e inserisci i contatti per la conferma d'ordine.",
    "shipBoxTitle": "Tempi di consegna da Cluj-Napoca (RO) — spedizione tracciata in tutta Europa",
    "shipStd": "Spedizione Standard · via terra",
    "shipStdT": "3-5 giorni lavorativi (Europa centrale e occidentale)",
    "shipExp": "Spedizione Express · via aerea",
    "shipExpT": "24-72 ore",
    "shipFree": "Gratuita sopra i 50 €",
    "shipProd": "Trasparenza: la stampa e la codifica personalizzata richiedono 24/48 ore lavorative aggiuntive prima della spedizione. Il metodo si sceglie al pagamento.",
    "legalTitle": "Prodotto personalizzato — diritto di recesso",
    "legalText": "Ai sensi dell'art. 16 lett. c) della Direttiva 2011/83/UE (art. 59 Codice del Consumo), il diritto di recesso di 14 giorni è escluso per i beni confezionati su misura o personalizzati: una volta avviata la produzione della tua card non è possibile annullare l'ordine. Resta garantita la conformità per difetti di fabbricazione.",
    "gdprText": "Loghi e foto caricati sono trattati esclusivamente per la produzione della card (art. 6.1.b GDPR), conservati sui nostri server UE e cancellabili su richiesta.",
    "vatTitle": "IVA e fatturazione europea",
    "vatText": "Prezzi IVA esclusa. B2C Italia/UE: IVA del Paese di destinazione applicata al pagamento (regime OSS). B2B intra-UE con Partita IVA valida (VIES): inversione contabile — Reverse Charge, IVA 0 %. Fattura con tutti i dati fiscali.",
    "payStepNote": "Al passo 5 pagherai in una pagina sicura Stripe (carta, Apple Pay, Google Pay, PayPal, SEPA).",
    "oneScreen": "Editor ottimizzato per zoom 100%",
    "s1t": "Identità visiva",
    "s1d": "Logo, nome dell'attività, città e carattere tipografico: li vedrai subito sull'anteprima.",
    "fontLabel": "Carattere tipografico",
    "fontHint": "Applicato in tempo reale a tutti i testi della card",
    "photoTitle": "Foto della tua attività (opzionale)",
    "photoSub": "Carica una foto per il fronte e/o il retro: verrà inserita nell'area dedicata con dissolvenza elegante, senza coprire testi, logo e codice QR.",
    "photoFront": "Foto fronte",
    "photoBack": "Foto retro",
    "photoUpload": "Carica foto (JPG, PNG, WEBP · max 20 MB)",
    "photoRemove": "Rimuovi",
    "photoOk": "Foto caricata correttamente",
    "materialTitle": "Finitura naturale del materiale",
    "materialWood": "Legno naturale inciso a laser: venature uniche su ogni pezzo, logo e testi incisi in profondità per un calore artigianale autentico.",
    "materialSteel": "Acciaio spazzolato con incisione di precisione: superficie satinata, riflessi metallici e testi incisi per una presenza scenografica.",
    "materialNote": "Per la linea Boutique i colori sono definiti dal materiale. Il QR resta su placca bianca ad alto contrasto per una scansione impeccabile.",
    "qrTitle": "QR code generato automaticamente",
    "qrSub": "Il QR è generato dal tuo link Google ed è già visibile sull'anteprima live. Sulla card definitiva punterà alla tua pagina recensioni intelligente, con customer care integrato.",
    "qrUpload": "Carica un QR personalizzato",
    "qrCustomDone": "QR personalizzato caricato",
    "qrReset": "Usa il QR generato",
    "logoLabel": "Logo aziendale",
    "logoUpload": "Carica il tuo logo (PNG, JPG, WEBP, SVG, PDF · max 20 MB)",
    "logoDone": "Logo caricato — clicca per sostituire",
    "logoDonePdf": "Logo caricato (PDF — verrà elaborato in produzione) — clicca per sostituire",
    "nameLabel": "Nome attività *",
    "namePh": "Es. Hotel Belvedere",
    "cityLabel": "Città",
    "cityPh": "Es. Rimini",
    "s2t": "Scegli formato e aspetto",
    "s2d": "Seleziona il supporto fisico e lo stile del layout.",
    "layoutStyle": "Stile layout",
    "s3t": "Colori, finitura & foto",
    "s3d": "Scegli i colori aziendali o una finitura di design e, se vuoi, aggiungi la foto della tua attività.",
    "s4t": "Google Review & QR code",
    "s4d": "Incolla il link delle recensioni della tua scheda Google Maps: lo verifichiamo, generiamo il QR e lo agganciamo al chip NFC.",
    "urlLabel": "Link scheda Google *",
    "urlPh": "https://maps.app.goo.gl/... oppure https://g.page/...",
    "verify": "Verifica link",
    "verifyOk": "Scheda agganciata con successo",
    "verifyOkName": "Attività rilevata",
    "verifyOkSuffix": "Il chip NFC e il QR punteranno a questa scheda.",
    "verifyErr": "Il link non sembra una scheda Google valida. Controlla e riprova.",
    "verifyHelp": "Dove lo trovo? Apri Google Maps → cerca la tua attività → Condividi → copia il link.",
    "s5t": "Contatti & chiusura",
    "s5d": "Ci servono per la conferma d'ordine e la produzione.",
    "emailLabel": "E-mail *",
    "emailPh": "nome@azienda.it",
    "phoneLabel": "Telefono *",
    "phonePh": "+39 333 000 0000",
    "qtyLabel": "Quantità",
    "shippingNote": "spedizione calcolata al checkout",
    "basePrice": "Prezzo base",
    "extraCost": "Costo extra",
    "kitNote": "Kit completo",
    "back": "Indietro",
    "next": "Continua",
    "submit": "Procedi al pagamento sicuro",
    "preview": "Anteprima live",
    "front": "Fronte",
    "backSide": "Retro",
    "logoOk": "Logo caricato correttamente",
    "logoErr": "Caricamento non riuscito",
    "orderErr": "Impossibile creare l'ordine. Riprova.",
    "logoDrop": "Trascina qui il logo o clicca per caricarlo (PNG, JPG, WEBP, SVG, PDF)",
    "logoTooSmall": "Immagine troppo piccola (min 150 px)",
    "logoVector": "File vettoriale · qualità di stampa ottimale",
    "quality": {
      "high": "Alta qualità",
      "ok": "Qualità adeguata",
      "low": "Risoluzione bassa",
      "reject": "Troppo piccola"
    },
    "cropZoom": "Zoom e ritaglio",
    "removeBg": "Rimuovi sfondo (IA)",
    "bgRemoved": "Sfondo rimosso",
    "undo": "Annulla",
    "original": "Originale",
    "processed": "Elaborato",
    "cropHint": "Trascina per riposizionare, usa il cursore per lo zoom.",
    "applyCrop": "Applica",
    "qrStyleTitle": "Personalizza il QR",
    "qrCustomColor": "Colore azienda",
    "qrLogoCenter": "Logo al centro",
    "qrContrastNote": "Manteniamo sempre un contrasto sufficiente: il QR viene testato prima della stampa.",
    "nfcOk": "Compatibile NFC",
    "nfcWarn": "Verifica NFC: attenzione",
    "nfcDetail": "Record NDEF {{bytes}} byte · chip consigliato {{chip}} · {{pct}}% della capacità NTAG213",
    "etaLine": "Produzione 24/48 h · consegna 3-5 gg (Express 24-72 h)",
    "edit": "Modifica",
    "duplicated": "Configurazione {{id}} duplicata: modifica e ordina.",
    "duplicateErr": "Ordine da duplicare non trovato."
  },
  "sectorsCfg": {
    "groups": {
      "food": "Ristorazione & Hospitality",
      "beauty": "Benessere & Persona",
      "health": "Salute & Professionisti",
      "services": "Servizi & Artigianato",
      "sport": "Sport & Svago",
      "retail": "Commercio & Retail",
      "other": "Altro"
    },
    "names": {
      "restaurant": "Ristoranti / Pizzerie",
      "bar": "Bar / Café",
      "hotel": "Hotel / B&B / Airbnb",
      "pastry": "Pasticcerie",
      "hair": "Parrucchieri / Barbieri",
      "beauty": "Centri Estetici",
      "spa": "Centri Massaggi / Spa",
      "tattoo": "Tatuatori",
      "medical": "Studi Medici / Dentistici",
      "vet": "Veterinari",
      "legal": "Studi Legali / Consulenti",
      "mechanic": "Meccanici / Officine",
      "home": "Servizi Casa / Pulizie",
      "plumber": "Idraulici / Elettricisti",
      "realestate": "Agenzie Immobiliari",
      "gym": "Palestre / Centri Sportivi",
      "dance": "Scuole Danza",
      "beach": "Stabilimenti Balneari / Camping",
      "fashion": "Negozi Abbigliamento",
      "optics": "Ottici / Gioiellerie",
      "grocery": "Alimentari",
      "cars": "Concessionarie",
      "other": "Altro (descrivi la tua attività)"
    },
    "cardText": {
      "food": "Ti è piaciuto da noi? La tua opinione conta!",
      "beauty": "Ti sei sentito al meglio? Raccontacelo!",
      "health": "La tua fiducia conta: lasciaci un feedback.",
      "services": "Lavoro ben fatto? La tua opinione ci aiuta.",
      "sport": "Allenamento top? Condividi la tua esperienza!",
      "retail": "Acquisto soddisfacente? Dillo su Google!",
      "other": "Per noi, la tua opinione conta!"
    }
  },
  "card": {
    "scanHere": "Scansiona qui il codice QR",
    "scanTap": "Scansiona o avvicina il telefono",
    "opinion": "Per noi, la tua opinione conta!",
    "tap": "Tocca con il telefono",
    "yourBiz": "La Tua Attività",
    "yourCity": "La tua città",
    "scan": "Scansiona il codice QR",
    "review5": "Raccontaci la tua esperienza su Google",
    "orNfc": "oppure avvicina il telefono",
    "frontCap": "Fronte · anteprima in tempo reale",
    "backCap": "Retro · anteprima in tempo reale"
  },
  "saas": {
    "eyebrow": "Piano Reputazione Continua",
    "title": "Gestione Strategica della Reputazione Post-Acquisto",
    "i1": "Aggiornamento URL in tempo reale: nessuna ristampa card necessaria",
    "i2": "Report mensile esecutivo: analisi dettagliata delle performance",
    "i3": "Canale di Supporto Prioritario: assistenza dedicata e tempestiva",
    "free": "1 anno gratis",
    "then": "poi 29 € / anno",
    "note": "*Primo anno di servizio incluso nell'acquisto iniziale della card. Abbonamento annuale con rinnovo automatico. Nessun costo nascosto."
  },
  "stats": {
    "badgeDownloaded": "Badge scaricato: pronto da pubblicare.",
    "badgeShareHint": "Scarica il badge come immagine: 1080×1080 per Instagram, 1200×630 per Facebook.",
    "badgeEyebrow": "Badge del mese",
    "badgeTitle": "Card più usata del mese",
    "badgeDetail": "Hai superato la tua media mensile di {{avg}} scansioni (+{{pct}}%).",
    "badgeFirst": "Primo mese di attività con il piede giusto: continua così.",
    "title": "Statistiche scansioni",
    "sub": "Quante volte la tua card è stata toccata (NFC) o scansionata (QR), giorno per giorno, e quanti clienti hanno poi aperto Google.",
    "days": "{{n}} giorni",
    "scans": "Scansioni",
    "clicks": "Clic su Google",
    "conv": "Conversione",
    "care": "Messaggi privati",
    "total": "Totale dall'attivazione",
    "last": "Ultima scansione",
    "empty": "Nessuna scansione ancora registrata: le statistiche si popolano automaticamente appena la card viene usata dai tuoi clienti."
  },
  "owner": {
    "langLabel": "Lingua e-mail",
    "langSaved": "Lingua aggiornata: report, promemoria e codici arriveranno in questa lingua.",
    "eyebrow": "Area titolare",
    "title": "Gestisci la tua card, in autonomia.",
    "sub": "Aggiorna il link Google collegato al chip NFC e al QR, controlla il Piano Reputazione Continua e recupera il link della tua pagina recensioni. Accesso sicuro con codice via e-mail.",
    "step1": "Verifica la tua identità",
    "step1d": "Inserisci l'e-mail usata per l'ordine {{id}}: ti invieremo un codice di accesso a 6 cifre.",
    "sendCode": "Inviami il codice",
    "codeSent": "Se l'e-mail corrisponde all'ordine, il codice è in arrivo.",
    "step2": "Inserisci il codice",
    "step2d": "Abbiamo inviato un codice a 6 cifre a {{email}}. Vale 10 minuti.",
    "enter": "Entra",
    "changeEmail": "Usa un'altra e-mail",
    "logout": "Esci",
    "orderNo": "Ordine",
    "linkTitle": "Link Google collegato alla card",
    "linkSub": "Il chip NFC e il QR puntano alla tua pagina recensioni intelligente: cambiando il link qui, la card si aggiorna all'istante, senza ristampa.",
    "currentLink": "Link attuale",
    "updatedAt": "Ultimo aggiornamento:",
    "verifySave": "Verifica e salva",
    "urlSaved": "Link aggiornato: la tua card punta già alla nuova scheda.",
    "linkNote": "Accettiamo link di Google Maps, maps.app.goo.gl o g.page. Verifichiamo la scheda prima di salvare.",
    "planTitle": "Piano Reputazione Continua",
    "planLegacy": "Incluso nel tuo ordine",
    "planInactive": "Il Piano Reputazione Continua non è attivo: la card continua a funzionare con l'ultimo link, ma per aggiornarlo è necessario riattivare il piano.",
    "genericErr": "Operazione non riuscita. Riprova."
  },
  "chat": {
    "openLabel": "Assistente IA",
    "closeLabel": "Chiudi",
    "status": "Online · risponde in pochi secondi",
    "welcome": "Buongiorno, sono l'Assistant di InfinityFeedback. Posso aiutarti a scegliere la card giusta, spiegarti come funzionano NFC e QR, il Piano Reputazione Continua, spedizioni e prezzi. Come posso esserti utile?",
    "quick": [
      "Come funziona la card?",
      "Quanto costa?",
      "Cos'è il Piano Reputazione Continua?",
      "Tempi di spedizione",
      "Preventivo per più sedi"
    ],
    "placeholder": "Scrivi la tua domanda…",
    "err": "Al momento non riesco a rispondere. Riprova tra qualche istante oppure lascia i tuoi contatti.",
    "disclaimer": "Assistente virtuale: le risposte hanno valore informativo.",
    "human": "Parla con un consulente",
    "leadTitle": "Ti mettiamo in contatto con un consulente",
    "leadSub": "Lascia i tuoi recapiti: il team ti ricontatta entro un giorno lavorativo con una proposta su misura.",
    "leadName": "Nome e cognome",
    "leadPhone": "Telefono",
    "leadBusiness": "Attività / Azienda",
    "leadMsg": "Esigenza (opzionale)",
    "leadConsent": "Acconsento al trattamento dei dati per essere ricontattato, come da",
    "leadSend": "Invia richiesta",
    "leadErr": "Invio non riuscito. Riprova.",
    "leadDone": "Richiesta inviata: un consulente ti contatterà a breve. Grazie!",
    "categories": "Categorie",
    "attach": "Allega file (immagini, PDF, Word, Excel, PowerPoint, video, audio)",
    "camera": "Fotocamera",
    "dropHere": "Rilascia qui i file",
    "tooBig": "File troppo grande: limite {{mb}} MB",
    "uploadErr": "Caricamento non riuscito",
    "analyzeFiles": "Analizza i file che ho caricato."
  },
  "auth": {
    "appleSoon": "Accesso con Apple in attivazione (servono le credenziali Apple Developer). Nel frattempo usa Google o l'e-mail.",
    "apple": "Continua con Apple",
    "googleErr": "Sessione Google non valida. Riprova ad accedere.",
    "google": "Continua con Google",
    "x": "Continua con X",
    "soon": "presto",
    "xSoon": "Accesso con X disponibile a breve",
    "or": "oppure",
    "loginEyebrow": "Area clienti",
    "loginTitle": "Bentornato.",
    "loginSub": "Accedi per vedere i tuoi ordini, gestire le card e il Piano Reputazione Continua.",
    "password": "Password",
    "passwordMin": "Password (min. 8 caratteri)",
    "login": "Accedi",
    "forgot": "Password dimenticata?",
    "noAccount": "Non hai un account? Registrati",
    "secure": "Connessione cifrata · dati trattati secondo il GDPR",
    "welcomeBack": "Bentornato, {{name}}!",
    "err": "Operazione non riuscita. Riprova.",
    "registerEyebrow": "Crea il tuo account",
    "registerTitle": "Registrati in 30 secondi.",
    "registerSub": "Un unico accesso per ordini, statistiche e gestione del piano.",
    "name": "Nome e cognome",
    "acceptTerms": "Ho letto e accetto i",
    "acceptPrivacy": "Ho letto l'informativa",
    "marketing": "Desidero ricevere novità e offerte via e-mail (facoltativo, revocabile in ogni momento).",
    "register": "Crea account",
    "haveAccount": "Hai già un account?",
    "registered": "Account creato. Benvenuto!",
    "forgotEyebrow": "Recupero accesso",
    "forgotTitle": "Reimposta la password.",
    "forgotSub": "Inserisci l'e-mail del tuo account: ti invieremo un link sicuro valido 1 ora.",
    "sendReset": "Inviami il link",
    "forgotSent": "Se l'e-mail corrisponde a un account, riceverai il link tra pochi istanti.",
    "resetTitle": "Scegli la nuova password.",
    "resetBtn": "Salva la nuova password",
    "resetOk": "Password aggiornata: ora puoi accedere.",
    "accountEyebrow": "Il tuo account",
    "accountTitle": "Ciao, {{name}}.",
    "orders": "I tuoi ordini",
    "noOrders": "Nessun ordine ancora associato a questa e-mail. Configura la tua prima card in 5 passaggi.",
    "manage": "Gestisci card e piano"
  },
  "rv": {
    "ownerLink": "Sei il titolare? Gestisci la tua card",
    "opinion": "La tua opinione conta davvero",
    "googleBtn": "Lascia una recensione su Google",
    "or": "oppure",
    "problemTitle": "Hai riscontrato un problema?",
    "problemSub": "Parla direttamente con il direttore, prima di recensire. Ti risponderà personalmente.",
    "formTitle": "Raccontaci cosa non ha funzionato",
    "fName": "Il tuo nome",
    "fContact": "Email o telefono",
    "fMsg": "Descrivi il problema riscontrato…",
    "fConsent": "Ho letto l'informativa privacy e acconsento al trattamento dei miei dati personali per essere ricontattato dalla direzione.",
    "privacyLink": "Leggi l'informativa",
    "send": "Invia direttamente al direttore",
    "back": "Indietro",
    "sentTitle": "Messaggio inviato alla direzione",
    "sentSub": "Grazie per averci dato la possibilità di rimediare. Verrai ricontattato al più presto.",
    "later": "Prosegui e recensisci su Google",
    "notFound": "Attività non trovata.",
    "sendError": "Invio non riuscito. Riprova.",
    "poweredBy": "Customer care intelligente by InfinityFeedback"
  },
  "checkout": {
    "standLine": "Espositore in rovere × {{n}}",
    "promoAuto": "sconto condivisione applicato",
    "acceptTerms": "Ho letto e accetto i",
    "andWithdrawal": "e la politica di",
    "acceptPrivacy": "Ho letto l'informativa",
    "planLabel": "Piano Reputazione Continua — 1° anno",
    "planIncluded": "Incluso",
    "planNote": "Pagamento unico, nessun abbonamento obbligatorio. Acquista la Card oggi: potrai aggiungere un piano in qualsiasi momento, senza cambiare la Card.",
    "eyebrow": "Checkout sicuro",
    "title": "Quasi fatto, {{name}}.",
    "billing": "Dati di fatturazione",
    "name": "Nome e cognome *",
    "company": "Azienda",
    "vat": "Partita IVA (B2B)",
    "vatPh": "Es. IT01234567890",
    "address": "Indirizzo *",
    "city": "Città *",
    "zip": "CAP *",
    "country": "Paese *",
    "shipping": "Metodo di consegna",
    "promo": "Codice sconto",
    "promoSub": "Hai un codice promozionale? Applicalo prima di pagare.",
    "promoPh": "Es. BENVENUTO10",
    "promoApply": "Applica",
    "promoOk": "applicato — sconto",
    "promoInvalid": "Codice non valido",
    "summary": "Riepilogo ordine",
    "discount": "Sconto",
    "free": "Gratuito",
    "total": "Totale",
    "customization": "Personalizzazione",
    "withPhoto": "con foto attività",
    "vatNote": "link Google verificato. IVA calcolata al pagamento secondo normativa UE.",
    "pay": "Paga in sicurezza con Stripe",
    "secured": "Pagamento crittografato · Carta di credito/debito",
    "notFound": "Ordine non trovato.",
    "backToCfg": "Torna al configuratore",
    "vatVerify": "Verifica",
    "vatValid": "Partita IVA valida (VIES)",
    "vatInvalid": "Partita IVA non valida secondo VIES",
    "vatUnknown": "Servizio VIES non raggiungibile: puoi proseguire, verificheremo noi.",
    "errGeneric": "Errore durante il checkout",
    "secureHeader": "Pagamento sicuro",
    "footerSecure": "Connessione crittografata SSL/TLS · I dati della carta sono gestiti da Stripe e non transitano mai sui nostri server.",
    "subtotal": "Subtotale",
    "bumpPreview": "Guarda un esempio",
    "bumpExamplesSub": "Anteprima della pagina 1 e tre modelli reali tratti dalla guida (20 in totale + risposte alle recensioni).",
    "bumpExamplesNote": "Guida in PDF, disponibile in italiano, inglese e romeno. Scaricabile subito dopo il pagamento e dall'e-mail di conferma.",
    "state": "Provincia / Regione",
    "stateReq": "Provincia *",
    "vatLine": "IVA",
    "vatPending": "calcolata in base al Paese",
    "bumpTitle": "Aggiungi la Guida ai Template di Recensione per soli 4,99 €",
    "bumpDesc": "PDF con 20 modelli pronti (a voce, WhatsApp, e-mail, cartelli) e risposte alle recensioni, in IT/EN/RO. Consegna digitale immediata dopo il pagamento.",
    "bumpLine": "Guida ai Template di Recensione (PDF)",
    "valueProp": "La soluzione professionale per semplificare e ottimizzare la tua presenza digitale.",
    "googleHonest": "Lo strumento più semplice per invitare i tuoi clienti a lasciare un feedback autentico su Google, riducendo l'attrito. Nessun rating automatico: solo recensioni vere.",
    "typePrivate": "Privato (B2C)",
    "typeBusiness": "Azienda (B2B)",
    "companyReq": "Ragione sociale *",
    "vatReq": "Partita IVA UE *",
    "reverseCharge": "L'IVA sarà stornata (reverse charge) dopo la validazione VIES.",
    "vatHint": "Inserisci la P.IVA con prefisso Paese (es. IT, RO, DE) e verifica su VIES.",
    "ossNote": "L'IVA è calcolata automaticamente in base al Paese UE di destinazione (regime OSS). Prezzi mostrati IVA esclusa; il totale include l'IVA dovuta.",
    "paymentTitle": "Pagamento",
    "loadingPayment": "Caricamento del modulo di pagamento sicuro…",
    "orCard": "oppure paga con carta",
    "andThe": "e la",
    "acceptDigital": "Acconsento all'esecuzione immediata del contratto con fornitura di contenuto digitale e riconosco che perderò il diritto di recesso di 14 giorni una volta avviato il download o l'accesso.",
    "acceptDigitalRef": "Art. 16, lett. m, Direttiva 2011/83/UE",
    "payNow": "Paga ora",
    "paying": "Elaborazione sicura in corso…",
    "trust1": "Crittografia SSL 256-bit",
    "trust2": "Transazione sicura al 100%",
    "trust3": "Consegna digitale immediata",
    "methodsNote": "Metodi disponibili in base a dispositivo e Paese · Pagamenti elaborati da Stripe",
    "hintFill": "Completa i dati di fatturazione per attivare il pagamento.",
    "hintConsents": "Spunta le due caselle di consenso per procedere.",
    "expressBlocked": "Completa i dati e i consensi prima del pagamento rapido."
  },
  "success": {
    "ownerArea": "Apri l'area titolare",
    "guideDownload": "Scarica la Guida ai Template di Recensione (PDF)",
    "invoiceDownload": "Scarica la fattura (PDF)",
    "planTitle": "Piano Reputazione Continua",
    "planActive": "Attivo — primo anno incluso",
    "planCanceled": "Disdetto — resta attivo fino alla scadenza",
    "planRenews": "Primo rinnovo automatico a 29 €/anno il {{date}}. Ti avviseremo via e-mail prima dell'addebito.",
    "planEnds": "Il servizio termina il {{date}}. Nessun ulteriore addebito.",
    "planPending": "Attivazione in corso: i dettagli del rinnovo saranno disponibili tra pochi istanti.",
    "planManage": "Gestisci piano, fattura o disdetta",
    "planPortalErr": "Portale non disponibile al momento. Riprova.",
    "polling": "Conferma del pagamento in corso…",
    "pollingSub": "Stiamo verificando l'esito con Stripe. Qualche secondo.",
    "title": "Ordine confermato. Benvenuto in InfinityFeedback.",
    "sub": "La tua card smart entra ora in produzione con la personalizzazione scelta.",
    "orderNo": "Numero ordine",
    "product": "Prodotto",
    "biz": "Attività",
    "city": "Città",
    "delivery": "Consegna",
    "paid": "Totale pagato",
    "emailNotice": "Ti abbiamo inviato un'e-mail di conferma con il riepilogo completo della personalizzazione a",
    "reviewTitle": "La tua pagina recensioni è attiva",
    "reviewSub": "Questo è l'indirizzo che programmeremo sulla tua card NFC + QR: da qui i clienti potranno lasciare la recensione su Google o contattarti in privato. Inquadra il QR per provarla subito.",
    "reviewCopy": "Copia link",
    "reviewCopied": "Link copiato negli appunti",
    "reviewOpen": "Apri la pagina",
    "home": "Torna alla home",
    "timeout": "Verifica in sospeso",
    "timeoutSub": "Non siamo riusciti a confermare il pagamento in tempo. Se hai completato il pagamento, riceverai a breve l'e-mail di conferma dell'ordine."
  },
  "cancel": {
    "title": "Pagamento annullato",
    "sub": "Nessun addebito è stato effettuato. Il tuo ordine personalizzato è ancora salvato: puoi completare il pagamento quando vuoi.",
    "retry": "Riprendi il checkout",
    "home": "Torna alla home"
  },
  "legal": {
    "eyebrow": "Documenti legali",
    "updated": "Ultimo aggiornamento: luglio 2026",
    "note": "Documento disponibile nella lingua selezionata."
  },
  "sticky": {
    "title": "Ordina la tua Card Smart Google Recensioni",
    "from": "da {{price}} · NFC + QR",
    "cta": "Ordina"
  },
  "trust": {
    "aria": "Garanzie e vantaggi",
    "payment": {
      "t": "Pagamento sicuro",
      "d": "Stripe · carte, Apple Pay, Google Pay"
    },
    "setup": {
      "t": "Configurazione inclusa",
      "d": "Card pronta all'uso, collegata alla tua pagina Google"
    },
    "shipping": {
      "t": "Spedizione gratuita da {{threshold}}",
      "d": "Consegna in Europa in 3-5 giorni lavorativi"
    },
    "nosub": {
      "t": "Nessun abbonamento obbligatorio",
      "d": "Paghi una volta, nessun canone"
    },
    "langs": {
      "t": "Supporto in {{n}} lingue",
      "d": "Sito, e-mail e fatture nella tua lingua"
    }
  },
  "draft": {
    "title": "Hai una configurazione salvata",
    "desc": "{{name}} · salvata il {{when}}. I dati restano solo sul tuo dispositivo.",
    "resume": "Riprendi la configurazione",
    "new": "Inizia una nuova"
  },
  "teaser": {
    "eyebrow": "Anteprima live",
    "placeholder": "Nome della tua attività",
    "cta": "Crea la tua card",
    "ctaActive": "Continua con questo nome",
    "hint": "Scrivi il nome: la card si aggiorna in tempo reale. Nessun dato viene salvato finché non ordini.",
    "color": "Colore della card"
  },
  "transparency": {
    "title": "Trasparenza totale",
    "text": "Mostriamo esclusivamente dati reali e verificati. Nessuna recensione, statistica o testimonial viene simulato."
  },
  "value": {
    "items": [
      "Attivazione in meno di 5 minuti",
      "Compatibile con Google Reviews",
      "Nessuna app da installare",
      "Card NFC + QR personalizzate",
      "Dashboard professionale con statistiche reali",
      "Pagamenti sicuri",
      "GDPR Ready",
      "Assistenza dedicata",
      "Consegna gratuita a Rimini e Cluj-Napoca (promozione di lancio)"
    ]
  },
  "pricing": {
    "seoTitle": "Prezzi — Card NFC + QR e piani opzionali | InfinityFeedback",
    "seoDesc": "Acquista la Card Google NFC + QR senza abbonamento obbligatorio e aggiungi quando vuoi un piano Basic, Professional, Business o Special Gold.",
    "eyebrow": "Prezzi semplici e trasparenti",
    "title": "La Card oggi. Un piano quando vuoi.",
    "sub": "Acquista la Card Google NFC + QR senza alcun abbonamento obbligatorio. I piani sono un'evoluzione della piattaforma: analisi, IA e automazioni per ottenere di più.",
    "cardsEyebrow": "Card senza canone",
    "cardsTitle": "Card Google NFC + QR: Standard o Personalizzata",
    "cardsText": "Entrambe funzionano perfettamente anche acquistate una sola volta, senza canoni.",
    "promise": "Acquista la Card oggi. Potrai aggiungere un piano in qualsiasi momento, senza cambiare la Card.",
    "oneOff": "una tantum",
    "mostChosen": "Più scelto",
    "perMonth": "/mese",
    "choose": "Scegli il piano",
    "billingNote": "Fatturazione mensile, IVA calcolata al checkout, disdici quando vuoi. Pagamento sicuro con Stripe.",
    "compareTitle": "Confronta i piani: {{n}} funzioni",
    "feature": "Funzione",
    "error": "Impossibile avviare il pagamento del piano.",
    "activated": "Piano {{name}} attivato",
    "yourPlan": "Il tuo piano",
    "noPlan": "Nessun piano attivo: la tua Card funziona comunque.",
    "changePlan": "Gestisci piano",
    "upgrade": "Aggiungi un piano",
    "groups": {
      "core": "Base",
      "analytics": "Analisi e statistiche",
      "ai": "Intelligenza artificiale",
      "automation": "Automazioni e integrazioni",
      "support": "Assistenza e sicurezza"
    },
    "plans": {
      "starter": {
        "name": "Basic",
        "tag": "Per piccole attività.",
        "bullets": [
          "Dashboard",
          "Statistiche base",
          "Assistenza",
          "Aggiornamenti"
        ]
      },
      "professional": {
        "name": "Professional",
        "tag": "Include Basic +",
        "bullets": [
          "Assistente IA",
          "Analisi recensioni",
          "Report automatici",
          "Statistiche avanzate"
        ]
      },
      "business": {
        "name": "Business",
        "tag": "Include Professional +",
        "bullets": [
          "Gestione multiutente",
          "Più sedi",
          "Classifica dipendenti",
          "Conversione scansione → recensione",
          "Report completi"
        ]
      },
      "special_gold": {
        "name": "Special Gold",
        "tag": "Include tutto, più:",
        "bullets": [
          "IA avanzata",
          "Automazioni complete",
          "API",
          "Multi-sede avanzato",
          "Priorità assistenza",
          "Funzioni Enterprise",
          "Nuove funzionalità in anteprima"
        ]
      }
    },
    "features": {
      "card_works_alone": "Card NFC + QR funzionante senza abbonamento",
      "dashboard": "Dashboard cliente",
      "stats_basic": "Statistiche di base",
      "qr_dynamic": "QR dinamico modificabile",
      "google_link_edit": "Modifica link Google in qualsiasi momento",
      "email_support": "Assistenza via e-mail",
      "updates": "Aggiornamenti inclusi",
      "locations": "Sedi",
      "cards_included": "Card gestite",
      "users": "Utenti",
      "scans_live": "Scansioni live",
      "conversion_rate": "Conversione scansione → recensione",
      "reviews_today": "Recensioni oggi",
      "reviews_month": "Recensioni mese",
      "charts_weekly": "Grafico settimanale",
      "charts_monthly": "Grafico mensile",
      "history": "Andamento storico",
      "avg_stars": "Media stelle",
      "goals": "Obiettivi mensili",
      "reports_auto": "Report automatici",
      "export_pdf": "Esportazione PDF",
      "export_excel": "Esportazione Excel",
      "export_csv": "Esportazione CSV",
      "compare_locations": "Confronto tra sedi",
      "leaderboard_staff": "Classifica dipendenti",
      "leaderboard_locations": "Classifica sedi",
      "ai_assistant": "Assistente IA",
      "ai_reviews_analysis": "Analisi IA delle recensioni",
      "ai_insights": "Consigli IA (trend, orari e giorni migliori)",
      "ai_replies_google": "Risposte IA alle recensioni Google",
      "ai_marketing": "Marketing IA (post social, e-mail, newsletter)",
      "ai_advanced": "IA avanzata e modelli premium",
      "ai_memory": "Memoria IA del cliente",
      "notifications": "Centro notifiche",
      "smart_alerts": "Alert intelligenti",
      "webhooks": "Webhook",
      "api": "API e chiavi API",
      "integrations": "Integrazioni (CRM, WhatsApp, MCP)",
      "white_label": "White label",
      "automations_full": "Automazioni complete",
      "support_priority": "Assistenza prioritaria",
      "onboarding": "Onboarding dedicato",
      "early_access": "Accesso anticipato alle novità",
      "sla": "SLA garantito",
      "gdpr": "GDPR",
      "ssl": "SSL e pagamenti sicuri"
    }
  },
  "dash": {
    "eyebrow": "Dashboard cliente",
    "transparency": "Solo dati reali, mai simulati.",
    "noData": "Nessun dato disponibile al momento.",
    "noDataHint": "I dati appariranno appena i tuoi clienti inizieranno a usare le card NFC + QR. Nessun numero viene mai simulato.",
    "live": "Live (ultima ora)",
    "liveScans": "Scansioni",
    "liveReviews": "Recensioni",
    "lastEvent": "Ultimo evento",
    "prev": "Periodo precedente",
    "scansLower": "scansioni",
    "reviewsLower": "recensioni",
    "samples": "{{n}} misurazioni",
    "starsFrom": "da {{n}} recensioni Google",
    "starsNA": "Disponibile collegando la scheda Google",
    "d": "g",
    "kpi": {
      "scans": "Scansioni",
      "reviews": "Recensioni",
      "conversion": "Conversione scansione → recensione",
      "today": "Recensioni oggi",
      "week": "Recensioni settimana",
      "month": "Recensioni mese",
      "latency": "Tempo medio scansione → recensione",
      "stars": "Media stelle Google"
    },
    "trend": "Andamento",
    "trendSub": "Scansioni e recensioni nel periodo selezionato",
    "gran": {
      "day": "Giorno",
      "week": "Settimana",
      "month": "Mese"
    },
    "hours": "Fasce orarie",
    "hoursSub": "Ore del giorno con più scansioni (UTC)",
    "weekdays": "Giorni della settimana",
    "weekdaysSub": "I giorni migliori per chiedere una recensione",
    "wd": {
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mer",
      "thu": "Gio",
      "fri": "Ven",
      "sat": "Sab",
      "sun": "Dom"
    },
    "sources": "NFC vs QR",
    "devicesTitle": "Dispositivi",
    "devices": {
      "android": "Android",
      "iphone": "iPhone",
      "desktop": "Desktop",
      "other": "Altro"
    },
    "topCards": "Top card più utilizzate",
    "rankLocations": "Classifica sedi",
    "rankStaff": "Classifica dipendenti",
    "assignHint": "Assegna le card a sedi e dipendenti nella scheda Card.",
    "goal": "Obiettivo mensile",
    "goalSaved": "Obiettivo salvato",
    "saveGoal": "Salva obiettivo",
    "edit": "Modifica",
    "cancel": "Annulla",
    "roi": "Ritorno sull'investimento",
    "roiSub": "Calcolato solo su dati realmente registrati",
    "roiValueNA": "Non calcolato",
    "roiItems": {
      "scans": "Scansioni totali",
      "reviews": "Recensioni ottenute",
      "conversion": "Conversione",
      "reviews30": "Recensioni questo mese",
      "growth": "Crescita recensioni vs periodo precedente",
      "value": "Valore stimato recensioni"
    },
    "insights": "Consigli IA",
    "insightsSub": "Analisi automatica giornaliera basata esclusivamente sui tuoi dati reali",
    "refresh": "Aggiorna",
    "generatedAt": "Generato il",
    "allLocations": "Tutte le sedi",
    "allStaff": "Tutti i dipendenti",
    "allDevices": "Tutti i dispositivi",
    "allSources": "NFC + QR",
    "allCampaigns": "Tutte le campagne",
    "allEvents": "Tutti gli eventi",
    "search": "Cerca…",
    "tabs": {
      "overview": "Panoramica",
      "cards": "Card",
      "orders": "Ordini",
      "team": "Sedi e team",
      "history": "Storico",
      "reports": "Report",
      "api": "API",
      "plan": "Piano",
      "marketing": "Marketing IA"
    },
    "cardsTitle": "Le tue card",
    "cardsSub": "Assegna ogni card a una sede, a un dipendente o a una campagna: alimenta classifiche e confronti.",
    "cardLabel": "Etichetta (es. Cassa 1)",
    "noLocation": "Nessuna sede",
    "noStaff": "Nessun dipendente",
    "campaign": "Campagna (es. Estate 2026)",
    "save": "Salva",
    "assigned": "Assegnazione salvata",
    "linkCopied": "Copiato",
    "copyNfcLink": "Copia link da programmare sul chip NFC",
    "locations": "Sedi",
    "locationsSub": "Crea le sedi della tua attività",
    "locationName": "Nome sede",
    "city": "Città",
    "staff": "Dipendenti",
    "staffSub": "Aggiungi il tuo team",
    "staffName": "Nome e cognome",
    "role": "Ruolo",
    "add": "Aggiungi",
    "created": "Creato",
    "noneYet": "Ancora nessun elemento.",
    "archive": "Archivia",
    "restore": "Ripristina",
    "confirmDelete": "Eliminare definitivamente?",
    "teamHint": "Suggerimento: ogni card può essere assegnata a una sede e a un dipendente. Le scansioni successive verranno attribuite automaticamente per alimentare classifiche, confronti e report.",
    "history": "Storico completo",
    "historyCount": "{{n}} eventi",
    "scan": "Scansione",
    "review": "Recensione",
    "cols": {
      "when": "Quando",
      "type": "Tipo",
      "card": "Card",
      "source": "Origine",
      "device": "Dispositivo",
      "location": "Sede",
      "staffCol": "Dipendente",
      "campaign": "Campagna",
      "latency": "Tempo"
    },
    "export": "Esporta report",
    "exportSub": "PDF professionale, Excel o CSV con tutti i KPI del periodo",
    "schedule": "Report automatici via e-mail",
    "scheduleSub": "Ricevi il report giornaliero, settimanale o mensile",
    "freq": {
      "off": "Disattivato",
      "daily": "Giornaliero",
      "weekly": "Settimanale",
      "monthly": "Mensile"
    },
    "scheduleSaved": "Preferenze salvate",
    "sendNow": "Invia ora",
    "reportSent": "Report inviato",
    "reportNotSent": "Invio non riuscito: riprova più tardi",
    "lastSent": "Ultimo invio",
    "apiKeys": "Chiavi API",
    "apiKeysSub": "Collega CRM, fogli di calcolo o automazioni ai tuoi dati",
    "keyLabel": "Nome chiave (es. Zapier)",
    "createKey": "Crea chiave",
    "keyOnce": "Copia ora: la chiave completa non sarà più visibile",
    "lastUsed": "Ultimo uso",
    "apiDocs": "API v1 (API Ready)",
    "apiDocsSub": "Endpoint REST autenticati con la tua chiave",
    "apiAuth": "Autenticazione: header X-API-Key",
    "apiNote1": "Le risposte contengono gli stessi dati reali della dashboard, in JSON.",
    "apiNote2": "Versionamento: /api/v1. Le versioni future non romperanno le integrazioni esistenti.",
    "duplicate": "Duplica configurazione",
    "webhooks": "Webhook e automazioni",
    "webhooksSub": "Ricevi in tempo reale scansioni, recensioni e ordini nel tuo CRM o nelle tue automazioni (firma HMAC, retry automatici)",
    "webhookTestSent": "Evento di test inviato",
    "lockedWith": "Incluso nel piano {{plan}} e superiori.",
    "seePlans": "Vedi i piani",
    "locked": {
      "insights": "Consigli IA giornalieri basati sui tuoi dati reali",
      "reports": "Report automatici via e-mail",
      "marketing": "Marketing IA: post e newsletter dai tuoi dati reali",
      "exports": "Export PDF ed Excel",
      "locations": "Sedi, dipendenti, confronti e classifiche",
      "staff": "Classifica dipendenti",
      "api": "API, chiavi e webhook per CRM e automazioni",
      "webhooks": "Webhook",
      "google": "Profilo Google Business collegato: stelle e recensioni reali"
    },
    "google": "Profilo Google Business",
    "googleSub": "Valutazione media, numero recensioni e andamento reali della tua scheda Google",
    "googleNotConfigured": "Integrazione Google in configurazione: sarà attiva appena l'amministratore inserisce la chiave Places API.",
    "googlePlaceholder": "Link della scheda Google, Place ID oppure «Nome attività, Città»",
    "connect": "Collega",
    "googleConnected": "Profilo Google collegato",
    "refreshed": "Aggiornato",
    "googleTotal": "Recensioni su Google",
    "since": "dal",
    "googleTrend": "Andamento",
    "googleTrendSoon": "L'andamento appare dal secondo giorno di raccolta.",
    "openGoogle": "Apri su Google",
    "googleUpdated": "Aggiornato il",
    "marketing": "Marketing IA",
    "marketingSub": "Post e newsletter scritti dall'IA partendo esclusivamente dai tuoi numeri e dalle recensioni reali",
    "channels": {
      "facebook": "Facebook",
      "instagram": "Instagram",
      "linkedin": "LinkedIn",
      "google_business": "Google Business",
      "newsletter": "Newsletter"
    },
    "tones": {
      "professionale": "Professionale",
      "amichevole": "Amichevole",
      "elegante": "Elegante",
      "entusiasta": "Entusiasta"
    },
    "mkExtra": "Nota opzionale (es. evento, novità del mese)",
    "generate": "Genera",
    "mkGenerated": "Contenuto generato",
    "mkNote": "Nessun numero o recensione viene inventato: se i dati non bastano, l'IA lo dichiara.",
    "mkEmpty": "Ancora nessun contenuto: genera il primo post dai tuoi dati reali."
  },
  "upsell": {
    "eyebrow": "Prima di pagare — opzionale",
    "extraTitle": "Aggiungi 4 card a {{price}}",
    "extraText": "Stessa configurazione, {{per}} a card (−{{pct}}%). Ideale per cassa, tavoli e reception.",
    "premiumTitle": "Passa a Premium (+{{delta}} a card)",
    "premiumText": "Il tuo logo stampato sulla card, colori aziendali e QR personalizzato.",
    "planTitle": "Scopri i piani Professional",
    "planText": "Dashboard IA, report automatici e classifiche: attivabili dopo l'acquisto, senza vincoli.",
    "note": "Nessun obbligo: puoi cambiare idea in qualsiasi momento prima del pagamento.",
    "upgraded": "Prodotto aggiornato: {{name}}",
    "extraLine": "4 card aggiuntive"
  }
};
